
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class StatusIndicatorLine extends Vue {
  @Prop(Boolean) status!: boolean;
}
